import { Component, OnInit, Inject, OnChanges, SimpleChanges } from '@angular/core';
import { PrintService } from 'src/app/services/print.service';
import { Auth } from 'src/app/stores/auth.store';
import { SubmitDetail } from 'src/app/stores/submit-detail.store';
import { pushToObject, MappingService } from 'src/app/services/mapping.service';
import { sum, ConvertService } from 'src/app/services/convert.service';
import { totalStore } from 'src/app/stores/getTotal.store';
import { deliveryInspectOption } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SettingStore } from 'src/app/stores/settings/setting.store';

@Component({
  selector: 'app-application-detail-print',
  templateUrl: './application-detail-print.component.html',
})
export class ApplicationDetailPrintComponent implements OnInit, OnChanges {

  submitItem = [];
  printDate: Date;
  loading;
  COLUMNS: any = null;
  invoice;
  TotalBill;
  TotalInspect;
  registerInvoice = []
  totalPermit = null;
  totalControl = null;
  totalComControl = null;
  totalInvoice = null;
  groupdata;
  result;
  deliveryInspectList = deliveryInspectOption;
  selectedItem = this.deliveryInspectList[0];
  constructor(
    public dialogRef: MatDialogRef<ApplicationDetailPrintComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public ps: PrintService,
    public auth: Auth,
    public detail: SubmitDetail,
    public total: totalStore,
    private store:SettingStore

  ) {

  }

  async ngOnInit() {

    this.auth.fetchColumns('Submit_Column_Print', doc => {
      if (doc) {
        const { Submit_Column_Print } = doc;
        this.COLUMNS = Submit_Column_Print;
      }
    })
    this.printDate = new Date();
    const data = this.data.registerCoItems;
    
    this.submitItem = pushToObject(data);

    if (this.data.collection === 'register_return_application') {
      const b = 15 - this.submitItem.length;
      this.invoice = sum(data, 'itemCount')
      this.groupdata = MappingService.groupBy(this.submitItem, 'pickupInspectionKey', 'inspect_number')

      // var groups = new Set(this.submitItem.map(item => item.pickupInspectionKey));
      this.result = [];
      this.groupdata.forEach(g => {
        const value = this.submitItem.filter(i => i.pickupInspectionKey === g.pickupInspectionKey);
        this.result.push({
          inspect_number: g.inspect_number,
          inspect_date: g.inspect_date,
          values: value,
          valuesLength: value.length
        })
      })
      // delivery_return_application
      if (this.submitItem.length <= 15) {
        for (let i = 0; i < b; i++) {
          this.submitItem.push({
            pushFeild1: null,
            pushFeild2: null,
            pushFeild3: null,
          })
        }
      } else {
        this.submitItem = data
      }
    }
    
    if (this.data.collection !== 'register_return_application') {
      const b = 10 - this.submitItem.length;
      this.invoice = sum(data, 'itemCount')
      // delivery_return_application
      if (this.submitItem.length <= 10) {
        for (let i = 0; i < b; i++) {
          this.submitItem.push({
            pushFeild1: null,
            pushFeild2: null,
            pushFeild3: null,
          })
        }
      } else {
        this.submitItem = data
      }
    }


    const bill = []
    const inspect = []
    if (this.data.collection === 'register_return_application') {
      data.forEach(data => {
        bill.push(data.pickupBillKey)
        inspect.push(data.pickupInspectionKey)
      });
      this.TotalBill = ConvertService.uniqueArray(bill);
      this.TotalInspect = ConvertService.uniqueArray(inspect);
    }
  }
  _onSelectedItem(item) {
    this.selectedItem = item;
  }
  ngOnChanges(changes: SimpleChanges) {}
  ngOnDestroy(): void {
    this.total.depose()
  }

  close() {
    this.dialogRef.close()
  }
  print() {
    this.ps.print('#printms', 'a4');
    this.store.printHistory(this.data?.item, this.auth.user, success=>{})

  }

}
